// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

import _ from "lodash";
import React, { RefObject } from "react";
import { connect } from "react-redux";
import { Label } from "office-ui-fabric-react/lib/Label";
import { IconButton } from "office-ui-fabric-react/lib/Button";
import size from "lodash/size";
import { RouteComponentProps } from "react-router-dom";
import SplitPane from "react-split-pane";
import axios from "axios";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { bindActionCreators } from "redux";
import Select from "react-select";
//import pdfjsLib from "pdfjs-dist";
import * as pdfjsLib from "pdfjs-dist/legacy/build/pdf";
import HtmlFileReader from "../../../../common/htmlFileReader";
import { SkipButton } from "../../shell/skipButton";
import { strings } from "../../../../common/strings";
import {
    AssetState, AssetType, EditorMode, IApplicationState,
    IAppSettings, IAsset, IAssetMetadata, IProject, IRegion,
    ISize, ITag, IAuthenticationState,
    ILabel, RegionType
} from "../../../../models/applicationState";
import IApplicationActions, * as applicationActions from "../../../../redux/actions/applicationActions";
import IProjectActions, * as projectActions from "../../../../redux/actions/projectActions";
import IAppTitleActions, * as appTitleActions from "../../../../redux/actions/appTitleActions";
import "./editorPage.scss";
import EditorSideBar from "./editorSideBar";
import Confirm from "../../common/confirm/confirm";
import { constants } from "../../../../common/constants";
import { Spinner, SpinnerSize } from "office-ui-fabric-react/lib/Spinner";
import { getPrimaryRedTheme } from "../../../../common/themes";
// import { SkipButton } from "../../shell/skipButton";
import ODModalHeader from "../header/ODsubHeader";
import { ImageMap } from "../../common/imageMap/imageMap";
import Style from "ol/style/Style";
import Stroke from "ol/style/Stroke";
import Fill from "ol/style/Fill";
import JsonResponse from "./jsonResponse";
import { parseTiffData, renderTiffToCanvas, loadImageToCanvas } from "../../../../common/utils";
import { appInfo } from "../../../../common/appInfo";
import HeaderComponent from "../header/header";
import { documentPredictionEndPoint, deleteBlobEndPoint,
    accessTokenData, accessToken, refreshTokenEndPoint, refreshTokenCall,documentPredictionimgEndPoint } from '../../../../common/api-config'
import ServiceHelper from "../../../../services/serviceHelper";
import RangeSlider from 'react-bootstrap-range-slider';
import Canvas from "./canvas";
import { AssetPreview } from "../../common/assetPreviewTest/assetPreview";
import { SelectionMode } from "vott-ct/lib/js/CanvasTools/Interface/ISelectorSettings";


const cMapUrl = constants.pdfjsCMapUrl(pdfjsLib.version);

 
//import { useState } from 'react';
 
//import Slider from 'rc-slider';
//import 'rc-slider/assets/index.css';


/**
 * Properties for Editor Page
 * @member project - Project being edited
 * @member recentProjects - Array of projects recently viewed/edited
 * @member actions - Project actions
 * @member applicationActions - Application setting actions
 */
export interface IEditorPageProps extends RouteComponentProps, React.Props<EditorPage> {
    project: IProject;
    recentProjects: IProject[];
    loadAllTestFiles: IAsset[];
    appSettings: IAppSettings;
    loggedInUser: IAuthenticationState;
    actions: IProjectActions;
    applicationActions: IApplicationActions;
    appTitleActions: IAppTitleActions;
    uploadFilesCount: number;
}

/**
 * State for Editor Page
 */
export interface IEditorPageState {
    /** Array of assets in project */
    assets: IAsset[];
    /** The editor mode to set for canvas tools */
    editorMode: EditorMode;
    /** The selected asset for the primary editing experience */
    selectedAsset?: IAssetMetadata;
    /** Currently selected region on current asset */
    selectedRegions?: IRegion[];
    /** Most recently selected tag */

    /** Tags locked for region labeling */
    lockedTags: string[];

    /** Size of the asset thumbnails to display in the side bar */
    thumbnailSize: ISize;
    /**
     * Whether or not the editor is in a valid state
     * State is invalid when a region has not been tagged
     */
    isValid: boolean;
    /** Whether the show invalid region warning alert should display */
    showInvalidRegionWarning: boolean;
    /** Show tags when loaded */
    tagsLoaded: boolean;
    /** The currently hovered TagInputItemLabel */
    hoveredLabel: ILabel;
    /** Whether the task for loading all OCRs is running */
    /** Whether OCR is running in the main canvas */
    isCanvasRunningOCR?: boolean;
    isError?: boolean;
    errorTitle?: string;
    errorMessage?: string;
    /** Test Image States */
    selectedTag: string;
    imageUri: string;
    imageWidth: number;
    imageHeight: number;
    numPages: number;
    currentPage: number;
    outPutFormat: string;
    pdfFile: any;
    tiffImages: any[];
    analyzeResult: any;
    analyseDataLoad: boolean;
    userId: string;
    loadingFiles: boolean;
    uploadFilesCount: number;
    loadResultFormates: any[];
    selectedFormat: any;
    slValue:number;
    analyzePResult: any;
}

function mapStateToProps(state: IApplicationState) {
    return {
        recentProjects: state.recentProjects,
        project: state.currentProject,
        loadAllTestFiles: state.loadTestFiles,
        loggedInUser: state.loggedInUser,
        appSettings: state.appSettings,
        uploadFilesCount: state.uploadFilesCount,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(projectActions, dispatch),
        applicationActions: bindActionCreators(applicationActions, dispatch),
        appTitleActions: bindActionCreators(appTitleActions, dispatch),
    };
}

/**
 * @name - Editor Page
 * @description - Page for adding/editing/removing tags to assets
 */
@connect(mapStateToProps, mapDispatchToProps)
export default class EditorPage extends React.Component<IEditorPageProps, IEditorPageState> {
    public state: IEditorPageState = {
        selectedTag: null,
        lockedTags: [],
        analyzeResult: null,
        analyzePResult:null,
        analyseDataLoad: false,
        assets: null,
        imageUri: null,
        imageWidth: 0,
        outPutFormat: "",
        imageHeight: 0,
        pdfFile: null,
        numPages: 1,
        currentPage: 1,
        tiffImages: [],
        errorMessage: null,
        editorMode: EditorMode.Select,
        thumbnailSize: { width: 175, height: 155 },
        isValid: true,
        showInvalidRegionWarning: false,
        tagsLoaded: false,
        hoveredLabel: null,
        userId: null,
        loadingFiles: false,
        uploadFilesCount: null,
        loadResultFormates: [{ value: 'json', label: 'JSON' },{ value: 'xml', label: 'XML' }],
        selectedFormat: null,
        slValue:0,
    };


    /** shoe test Image */
    private currPdf: any;
    private tiffImages: any[];
    private imageMap: ImageMap;
    private timeInterval: any;
    private controller = new AbortController();
    private cancelToken;
    private loadingProjectAssets: boolean = false;
    private deleteFileConfirm: React.RefObject<Confirm> = React.createRef();
    private renameCanceled: () => void;
    private isUnmount: boolean = false;
    private canvas: RefObject<Canvas> = React.createRef();
    private image: React.RefObject<HTMLImageElement> = React.createRef();
    
    constructor(props) {
        super(props);
    }

    public async componentDidMount() {
       
        window.addEventListener("focus", this.onFocused);
        const user = this.props.loggedInUser;
        const userId = user.user.oid;
        this.setState({ userId });
        this.isUnmount = false;
        const projectId = this.props.match.params["projectId"];
        const projectName = this.props.match.params["projectName"];
        if (this.props.project) {
            // this.getFilesFromBlob();
            this.loadProjectAssets();
        } else if (projectId) {
            const recentProject = this.props.recentProjects.find((project) => project.id === projectId);
            const projectCopy = Object.assign({}, recentProject);
            projectCopy.folderPath = `${projectName}-${userId}/testing`;
            await this.props.actions.saveProject(projectCopy, false, false);
            await this.props.actions.loadProject(projectCopy);
        }
        this.getFilesFromBlob();
    }

    public getFilesFromBlob = () => {
        const projectCopy = Object.assign({}, this.props.project);
        projectCopy.folderPath = `${this.props.match.params["projectName"]}-${this.state.userId}/testing`;
        this.props.actions.loadBlobs(projectCopy, "testing");

    }

    
    public setslValue = (slValue) => {
       
      //  debugger;
      //  const apres = this.state.analyzeResult.predictions.filter(x=>(x.probability*100)>slValue);

       // const probper = (prdct.probability * 100).toFixed(2);
        this.setState({
            //slValue: slValue,
           // analyzePResult: this.state.analyzeResult.predictions,
        });
    }


    public async componentDidUpdate(prevProps: Readonly<IEditorPageProps>, prevState) {
        const { project } = this.props;

        if (project && this.state.assets && this.state.assets.length === 0) {
            await this.loadProjectAssets();
        }       
        if (prevProps.uploadFilesCount && prevProps.uploadFilesCount !== prevState.uploadFilesCount) {
            prevState.uploadFilesCount = prevProps.uploadFilesCount;
            this.getFilesFromBlob();
        }
        if (prevProps.loadAllTestFiles.length > 0 && prevProps.loadAllTestFiles.length !== (prevState.assets && prevState.assets.length)) {
            localStorage.setItem("testFilesLengthFromTest", prevProps.loadAllTestFiles.length.toString())
            prevState.loadingFiles = true;
            await this.loadProjectAssets();
            prevState.loadingFiles = false;
        }
    }

    public componentWillUnmount() {
        this.isUnmount = true;      
        window.removeEventListener("focus", this.onFocused);
        this.analyseData();
    }


    /** show Test Image based on left side selection */


    public loadTiffFile = async (asset: IAsset) => {
        const assetArrayBuffer = await HtmlFileReader.getAssetArray(asset);
        const tiffImages = parseTiffData(assetArrayBuffer);
        this.loadTiffPage(tiffImages, this.state.currentPage);
    }

    public loadTiffPage = (tiffImages: any[], pageNumber: number) => {
        const tiffImage = tiffImages[pageNumber - 1];
        const canvas = renderTiffToCanvas(tiffImage);
        this.setState({
            imageUri: canvas.toDataURL(constants.convertedImageFormat, constants.convertedImageQuality),
            imageWidth: tiffImage.width,
            imageHeight: tiffImage.height,
            numPages: tiffImages.length,
            currentPage: pageNumber,
            tiffImages,
        });
    }

    public loadImage = async () => {
        const asset = this.state.selectedAsset.asset;
        if (asset.type === AssetType.Image) {
            const canvas = await loadImageToCanvas(asset.path);
            this.setState({
                imageUri: canvas.toDataURL(constants.convertedImageFormat, constants.convertedImageQuality),
                imageWidth: canvas.width,
                imageHeight: canvas.height,
            });
        } else if (asset.type === AssetType.TIFF) {
            await this.loadTiffFile(asset);
        } else if (asset.type === AssetType.PDF) {
            await this.loadPdfFile(asset.id, asset.path);
        }
    }

    public loadPdfFile = async (assetId, url) => {
        try {
            const pdf = await pdfjsLib.getDocument({ url, cMapUrl, cMapPacked: true }).promise;
            // Fetch current page
            if (assetId === this.state.selectedAsset.asset.id) {
                await this.loadPdfPage(assetId, pdf, this.state.currentPage);
            }
        } catch (reason) {
            // PDF loading error
            console.error(reason);
        }   
    }

    public loadPdfPage = async (assetId, pdf, pageNumber) => {
        const page = await pdf.getPage(pageNumber);
        const defaultScale = 2;
        const viewport = page.getViewport({ scale: defaultScale });

        // Prepare canvas using PDF page dimensions
        const canvas = document.createElement("canvas");
        const context = canvas.getContext("2d");
        canvas.height = viewport.height;
        canvas.width = viewport.width;

        // Render PDF page into canvas context
        const renderContext = {
            canvasContext: context,
            viewport,
        };
        await page.render(renderContext).promise;
        if (assetId === this.state.selectedAsset.asset.id) {
            this.setState({
                imageUri: canvas.toDataURL(constants.convertedImageFormat, constants.convertedImageQuality),
                imageWidth: canvas.width,
                imageHeight: canvas.height,
                numPages: pdf.numPages,
                currentPage: pageNumber,
                pdfFile: pdf
            });
        }
    }

    public featureStyler = (feature) => {
        const regionId = feature.get("id");
        return new Style({
            stroke: new Stroke({
                color: "#fffc7f",
                width: 1,
            }),
            fill: new Fill({
                color: "rgba(255, 252, 127, 0.2)",
            }),
        });
    }

    public noOp = () => {
        // no operation
    }

    public renderImageMap = () => {
        return (
            <ImageMap
                initEditorMap={true}
                ref={(ref) => this.imageMap = ref}
                imageUri={this.state.imageUri}
                imageWidth={this.state.imageWidth}
                imageHeight={this.state.imageHeight}
                featureStyler={this.featureStyler}
                onMapReady={this.noOp}
            />
        );
    }


    public render() {
        const { project } = this.props;
        const { assets, analyseDataLoad, selectedAsset,slValue,analyzePResult, analyzeResult } = this.state;
      
      
        if (!project) {
            return (<div className="text-center mt-5">Loading...</div>);
        }

        // const schema = this.props.match.params["schema"] ? this.props.match.params["schema"] : "na";

        return (
            <>
                <HeaderComponent
                    history={this.props.history}
                    match={this.props.match}
                    location={this.props.location} />
                <ODModalHeader
                    history={this.props.history}
                    match={this.props.match}
                    actions={this.props.actions}
                    location={this.props.location}
                    project={this.props.project} />
                <div className="container-fluid animated fadeIn editor-page-test" id="testPageEditor">
                    <SplitPane split="vertical"
                        defaultSize={this.state.thumbnailSize.width}
                        minSize={175}
                        maxSize={175}
                        paneStyle={{ display: "flex" }}
                        onChange={this.onSideBarResize}
                        onDragFinished={this.onSideBarResizeComplete}>
                        <div className="editor-page-test-sidebar bg-lighter-1">
                            <div className="tag-input-header p-1 text-center">
                                <Link to={`/ODProjects/${this.props.match.params["projectName"]}/${this.props.match.params["projectId"]}/na/od/test`} type="button" className="btn-custom"  >
                                    <i className="fa fa fa-upload" aria-hidden="true"></i> Upload</Link>
                            </div>
                            {assets && size(assets) > 0 ?
                                <EditorSideBar
                                    assets={assets}
                                    selectedAsset={selectedAsset ? selectedAsset.asset : null}
                                    onBeforeAssetSelected={this.onBeforeAssetSelected}
                                    onDeleteSelected={this.deleteAsset}
                                    onAssetSelected={this.selectAsset}
                                    thumbnailSize={this.state.thumbnailSize}
                                    setImageUriInAsset={this.props.actions.updateAssetWithImageUri}
                                />
                                :
                                <>
                                {/* {this.showLoader()} */}
                                {/* {assets && size(assets) === 0 && !this.state.loadingFiles ? */}
                                <div className="text-center">Please (wait/upload) Files to Test</div>
                                {/* : 
                                 <Spinner
                                size={SpinnerSize.small}
                                label="Loading Files"
                                ariaLive="off"
                                labelPosition="bottom"
                                />
                                    } */}
                                </>
                            }
                        </div>
                        <div className="editor-page-test-content">
                            <div className="editor-page-test-content-main" >
                                {/* <div className="editor-page-test-content-main-body"> */}
                                {assets && size(assets) > 0 ?
                                     <div className="editor-page-test-content-main-body">
                                    {this.state.imageUri
                                        ?
                                        <>
                                        
                                        
                                        {
                                       
                                        
                                        selectedAsset && this.state.analyzeResult?
                                        
                                        
                                        <Canvas
                                        ref={this.canvas}
                                        selectedAsset={this.state.selectedAsset}
                                      // onAssetMetadataChanged={this.onAssetMetadataChanged}
                                    // onCanvasRendered={this.onCanvasRendered}
                                     //onSelectedRegionsChanged={this.onSelectedRegionsChanged}
                                       // editorMode={this.state.editorMode}
                                     selectionMode={SelectionMode.RECT}
                                        project={this.props.project}
                                       // lockedTags={this.state.lockedTags}
                                       >
                                               
                                               
                                                 <AssetPreview
                                              // additionalSettings={this.state.additionalSettings}
                                               autoPlay={true}
                                              // controlsEnabled={this.state.isValid}
                                              // onBeforeAssetChanged={this.onBeforeAssetSelected}
                                              // onChildAssetSelected={this.onChildAssetSelected}
                                               asset={this.state.selectedAsset.asset}
                                              // childAssets={this.state.childAssets}
                                                />
 </Canvas>
                                  :
                                  
                                   <ImageMap
                                            initEditorMap={true}
                                            ref={(ref) => this.imageMap = ref}
                                            imageUri={this.state.imageUri || ""}
                                            imageWidth={this.state.imageWidth}
                                            imageHeight={this.state.imageHeight}
                                            featureStyler={this.featureStyler}
                                            onMapReady={this.noOp}
                                                   />
                                            
                                        
                                          
                                       
                                      
                                    }
    
                                        { this.shouldShowPreviousPageButton() &&
                                            <IconButton
                                                className="toolbar-btn prev"
                                                title="Previous"
                                                iconProps={{iconName: "ChevronLeft"}}
                                                onClick={this.prevPage}
                                            />
                                        }
                                        { this.shouldShowNextPageButton() &&
                                            <IconButton
                                                className="toolbar-btn next"
                                                title="Next"
                                                onClick={this.nextPage}
                                                iconProps={{iconName: "ChevronRight"}}
                                            />
                                        }
                                        { this.shouldShowMultiPageIndicator() &&
                                            <p className="page-number">
                                                Page {this.state.currentPage} of {this.state.numPages}
                                            </p>
                                        }
                                        </>
                                        :
                                        <div className="canvas-ocr-loading">
                                            <div className="canvas-ocr-loading-spinner">
                                                <Spinner size={SpinnerSize.large} label="Loading File..." ariaLive="assertive" labelPosition="right" />
                                            </div>
                                        </div>
                                    }
                                 </div>:
                                 <div className="text-center mt-5">Please Select any file</div>
                                }
                                {/* </div> */}
                            </div>
                            <div className="editor-page-test-right-sidebar hidden">

                            </div>
                            <div className="editor-page-test-right-sidebar">

                                <div className="tag-input">
                                <div>
                                                <label>Select Format:</label>
                                                <Select options={this.state.loadResultFormates}
                                                onChange={this.getFormatType}
                                                value={this.state.selectedFormat}
                                                placeholder="Select Format"
                                                // className="react-select-container zindex-20"
                                                isClearable={true}
                                                theme={(theme) => ({
                                                    ...theme,
                                                    colors: {
                                                        ...theme.colors,
                                                        primary25: "#161a1f",
                                                        primary: "#6b727d",
                                                        neutral0: "#222830",
                                                        neutral20: "#44474c",
                                                        neutral30: "#272c33",
                                                        neutral50: "#fff",
                                                        neutral80: "#9da7b5",
                                                    },
                                                })}

                                            />
                                            </div>


                                    <div className="tag-input-header p-1">

                                        <div className="tag-input-toolbar test-conttols">                                          
                                            <button
                                                disabled={assets && size(assets) === 0 || !assets}
                                                onClick={() => this.analyseData("raw")} className="btn-custom">
                                                <i className="fa fa-code" aria-hidden="true"></i> Result
                                            </button>
                                            &nbsp;
                                            {/* <button
                                                disabled={size(assets) === 0}
                                                className="btn-custom" onClick={() => this.analyseData("transform")}>
                                                <i className="fa fa-code" aria-hidden="true"></i> Transform
                                            </button>
                                            &nbsp; */}
                                            <button type="button" disabled={assets && size(assets) === 0 || !assets} onClick={() => this.downloadJson()} title="Export1" className="btn-custom" >
                                                <i className="fa fa-file-export" aria-hidden="true"></i>Export </button>
                                        </div>
                                    </div>

                                    <div >
                                        {/*
                                    <h4 className="predtbl" >Threshold Value</h4>
                                      
                                      
                                        <div className="divsl">
                                        <RangeSlider
                                        min={0}
                                        max={100}
                                        step={1}
      value={slValue}
      onChange={changeEvent => this.setslValue(changeEvent.target.value)}
      tooltip='on'
    />
                                        </div>
    */}

                                    <div >
{
                                    this.state.analyzeResult &&
                                    this.state.analyzeResult.predictions && 
                                    this.state.analyzeResult.predictions.length>0 &&
                                                 <div>
                                                     <h4 className="predtbl" >Predictions</h4>
                                                

                                                       <div className="divscr" >


                                                     <table className="table table-dark table-striped">
                            <thead>
                                <tr>
                                    <th>Tag</th>
                                    <th>Profitability</th>
                                    
                                </tr>
                            </thead>
                            <tbody>
                            <>
                                
                                {
                                    
                                    this.state.analyzeResult.predictions.map((prdct)=>
                                {
                                    const probper = (prdct.probability * 100).toFixed(2);
                                    return(
                                 <tr>
                                      <td>{prdct.tagName}</td>
                                            <td >{probper} %</td>
                                           
                               </tr>
                                    );
                                })
                            }
                            </>
                       </tbody>
                       </table>
                       </div>
                       </div>
    }     
        
                                                         </div>
                                    </div>
                                    <div className="tag-input-body-container">
                                        <div className="tag-input-body">

                                            <div className="tag-input-items">
                                           
                                            </div></div>

                                        <div className="sec-rt">
                                            {this.state.analyzeResult &&
                                                <JsonResponse
                                                    history={this.props.history}
                                                    match={this.props.match}
                                                    location={this.props.location}
                                                    project={this.props.project}
                                                    outPutFormat={this.state.outPutFormat}
                                                    jsonData={this.state.analyzeResult}
                                                />
                                                

                                            }
                                            {this.state.errorMessage
                                                && <p className="text-center mt-5">{this.state.errorMessage["error"]["message"]}</p>}
                                            {/* {this.state.analyseDataLoad
                                                && <Spinner
                                                    label="Loading JSON"
                                                    ariaLive="off"
                                                    className="loading" size={SpinnerSize.large} />} */}

                                               
                                        </div>
                                          
                                   
                                   
                                    </div>
                                </div>
                            </div>
                            <Confirm title="Delete File"
                                ref={this.deleteFileConfirm}
                                message="Are you sure you want to delete this File ?"
                                confirmButtonTheme={getPrimaryRedTheme()}
                                onCancel={this.onDeleteFileCancel}
                                onConfirm={this.onDeleteFile} />
                        </div>
                    </SplitPane>
                    <SkipButton skipTo="testPageEditor">{strings.common.skipToMainContent}</SkipButton>
                </div>
                {this.state.analyseDataLoad &&
                    <div className="canvas-ocr-loading">
                        <div className="canvas-ocr-loading-spinner">
                            <Label className="p-0" ></Label>
                            <Spinner size={SpinnerSize.large} label="Your Document is transforming please wait ..!" ariaLive="assertive" labelPosition="right"/>
                        </div>
                    </div>
                }
            </>
        );
    }


    private onCanvasRendered = async (canvas: HTMLCanvasElement) => {
        // When active learning auto-detect is enabled
        // run predictions when asset changes
      //  if (this.props.project.activeLearningSettings.autoDetect && !this.state.selectedAsset.asset.predicted) {
        //    await this.predictRegions(canvas);
      //  }
    }
    private onSelectedRegionsChanged = (selectedRegions: IRegion[]) => {
      //  this.setState({ selectedRegions });
    }
    /** delete file */
    private deleteAsset = async (asset: IAsset) => {
        await this.updateAssetState(asset.id, false);
        this.deleteFileConfirm.current.open(asset);
    }

    private onDeleteFileCancel = () => {
        if (this.renameCanceled) {
            this.renameCanceled();
            this.renameCanceled = null;
        }
    }

    private onDeleteFile = async (asset: IAsset) => {
        this.updateAssetState(asset.id, true);
        const { project } = this.props;
        const parts = asset.name.split("/");
        const fileName = parts.pop();
        const headers = accessToken();
        const URL = deleteBlobEndPoint(project.name, fileName);
        try {
            const deleted = await axios(URL, { method: "GET", headers });
            if (deleted && deleted.data === "Blobs deleted successfully!") {
            this.props.actions.deleteAsset(asset);
            this.updateAssetState(asset.id, false);
            this.loadProjectAssets();
            } else {
                this.updateAssetState(asset.id, false);
                this.loadProjectAssets();
            }
        } catch (err) {
            let response;
            if (err.response.status == 401) {
                const body = {
                    refreshToken: refreshTokenCall()
                }
                response = await ServiceHelper.postWithAutoRetry(
                    refreshTokenEndPoint(), body, { headers });
                if (response.data.status == 200) {
                    const signInUserSession = localStorage.getItem("signInUserSession");
                    const user = signInUserSession && JSON.parse(signInUserSession);
                    const updateAccessToken = Object.assign({}, user)
                    updateAccessToken.access_token = response.data.access_token
                    updateAccessToken.refresh_token = response.data.refresh_token
                    try {
                        const deleted = await axios(URL, { method: "GET", headers });
                        if (deleted && deleted.data === "Blobs deleted successfully!") {
                            this.props.actions.deleteAsset(asset);
                            this.updateAssetState(asset.id, false);
                            this.loadProjectAssets();
                            } else {
                                this.updateAssetState(asset.id, false);
                                this.loadProjectAssets();
                            }
                    } catch (err) {
                        ServiceHelper.handleServiceError(err);
                    }

                }
            } else {
                ServiceHelper.handleServiceError(err);
            }
        }
    }

    private updateAssetState = (id: string, isDeleting: boolean) => {
        this.setState((state) => ({
            assets: state.assets.map((asset) => {
                if (asset.id === id) {
                    const updatedAsset = { ...asset, isDeleting };
                    return updatedAsset;
                } else {
                    return asset;
                }
            }),
        }), () => {
            if (this.state.selectedAsset && id === this.state.selectedAsset.asset.id) {
                const asset = this.state.assets.find((asset) => asset.id === id);
                if (asset) {
                    this.setState({
                        selectedAsset: { ...this.state.selectedAsset, asset: { ...asset } },
                    });
                }
            }
        });
    }

    /**
     * Called when the asset side bar is resized
     * @param newWidth The new sidebar width
     */
    private onSideBarResize = (newWidth: number) => {
        this.setState({
            thumbnailSize: {
                width: newWidth,
                height: newWidth / (4 / 3),
            },
        });
    }

    /**
     * Called when the asset sidebar has been completed
     */
    private onSideBarResizeComplete = () => {
        const appSettings = {
            ...this.props.appSettings,
            thumbnailSize: this.state.thumbnailSize,
        };

        this.props.applicationActions.saveAppSettings(appSettings);
    }

    /**
     * Returns a value indicating whether the current asset is taggable
     */
    private isTaggableAssetType = (asset: IAsset): boolean => {
        return asset.type !== AssetType.Unknown;
    }

    /**
     * Raised when the selected asset has been changed.
     * This can either be a parent or child asset
     */
    private onAssetMetadataChanged = async (assetMetadata: IAssetMetadata): Promise<void> => {
        // Comment out below code as we allow regions without tags, it would make labeler's work easier.

        const initialState = assetMetadata.asset.state;

        const asset = { ...assetMetadata.asset };

        if (this.isTaggableAssetType(assetMetadata.asset)) {
            assetMetadata.asset.state = _.get(assetMetadata, "labelData.labels.length", 0) > 0 ?
                AssetState.Tagged :
                AssetState.Visited;
        } else if (assetMetadata.asset.state === AssetState.NotVisited) {
            assetMetadata.asset.state = AssetState.Visited;
        }

        // Only update asset metadata if state changes or is different
        if (initialState !== assetMetadata.asset.state || this.state.selectedAsset !== assetMetadata) {
            await this.props.actions.saveAssetMetadata(this.props.project, assetMetadata);
            if (this.props.project.lastVisitedAssetId === assetMetadata.asset.id) {
                this.setState({ selectedAsset: assetMetadata });
            }
        }

        // Find and update the root asset in the internal state
        // This forces the root assets that are displayed in the sidebar to
        // accurately show their correct state (not-visited, visited or tagged)
        const assets = [...this.state.assets];
        const assetIndex = assets.findIndex((a) => a.id === asset.id);
        if (assetIndex > -1) {
            assets[assetIndex] = {
                ...asset,
            };
        }

        this.setState({ assets, isValid: true });

        // Workaround for if component is unmounted
        if (!this.isUnmount) {
            this.props.appTitleActions.setTitle(`${this.props.project.name} - [ ${asset.name} ]`);
        }
    }

    private onBeforeAssetSelected = (): boolean => {
        if (!this.state.isValid) {
            this.setState({ showInvalidRegionWarning: true });
        }

        return this.state.isValid;
    }

    private selectAsset = async (asset: IAsset): Promise<void> => {
        // Nothing to do if we are already on the same asset.
       // this.cancelToken = undefined; - comenting for always result
        if (this.state.selectedAsset && this.state.selectedAsset.asset.id === asset.id) {
            return;
        }

        if (!this.state.isValid) {
            this.setState({ showInvalidRegionWarning: true });
            return;
        }
        const {assets } = this.state;
        localStorage.setItem("lastVisttedtestAssetId", asset.id);
     //debugger;
        /*
        const assetMetadata = {
            asset: { ...asset },
            regions: [],
            version: appInfo.version,
            labelData: null,
        }*/
//new start
        const assetMetadata = await this.props.actions.loadAssetMetadata(this.props.project, asset);
       // debugger;
        console.log("asset metadata"+JSON.stringify(assetMetadata));
        try {
            if (!assetMetadata.asset.size) {
                const assetProps = await HtmlFileReader.readAssetAttributes(asset);
               // assetMetadata.asset.size = { width: assetProps.width/2.2, height: assetProps.height/1.7 };
               assetMetadata.asset.size = { width: 1000, height: 1000 };
            }
        } catch (err) {
            console.warn("Error computing asset size");
        }
//new end


        this.setState({
            imageUri: null,
            selectedAsset: assetMetadata,
        }, async () => {
            await this.loadImage();
           // await this.analyseData("transform");
            // await this.onAssetMetadataChanged(assetMetadata);
        });
    }


    private loadProjectAssets = (): Promise<void> => {
        if (this.loadingProjectAssets) {
            return;
        }

        this.loadingProjectAssets = true;
        const projectCopy = Object.assign({}, this.props.project);
        projectCopy.folderPath = `${this.props.match.params["projectName"]}-${this.state.userId}/testing`;
        const rootAssets: IAsset[] = this.props.loadAllTestFiles;

        
        if (this.state.assets && this.state.assets.length === rootAssets.length
            && this.state.assets.map((asset) => asset.id).join(",") === rootAssets.map((asset) => asset.id).join(",")) {
            this.loadingProjectAssets = false;
            return;
        }
        const lastVisited = localStorage.getItem("lastVisttedtestAssetId");
        const lastVisitedAsset = rootAssets.find((asset) => asset.id === lastVisited);
        this.setState({
            assets: rootAssets,
        }, async () => {
            if (rootAssets.length > 0) {
                this.selectAsset(lastVisitedAsset ? lastVisitedAsset : rootAssets[0]);
            }
            this.loadingProjectAssets = false;
        });
    }

    private updateAssets = () => {
        const rootAssets: IAsset[] = this.props.loadAllTestFiles;
        this.setState({
            assets: rootAssets,
        });
    }

    private downloadJson = async () => {
        const parts = this.state.selectedAsset.asset.name.split("/");
        const fileName = parts.pop() || parts.pop();
        const nameFile = fileName.replace(/(.*)\.[^.]+$/, "$1");
        const myData = this.state.analyzeResult
        const json = JSON.stringify(myData);
        const blob = new Blob([json], { type: 'application/json' });
        const href = await URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = href;
        link.download = nameFile + ".json";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }

    // https://document-prediciton.azurewebsites.net/api/HttpTrigger1?project_name=project_2

    /** Analyse data from azure */
    private analyseData = async (outPutFormat?: string) => {
       // debugger;
       // if (this.cancelToken !== undefined) {
      //      this.cancelToken.cancel("Operation canceled due to going new component.");
      //  } else {


          // Save the cancel token for the current request
        if (outPutFormat) {
          //  debugger;
        this.setState({ analyzeResult: null, analyzePResult:null, analyseDataLoad: true });
        const parts = this.state.selectedAsset.asset.name.split("/");
        const fileName = parts.pop() || parts.pop();
        const projectName = this.props.match.params["projectName"]
        const headers = accessToken();
        const accessTokenBody = accessTokenData();
        this.cancelToken = axios.CancelToken.source();

          //new change start

          //const name = filfilename;
          const lastDot = fileName.lastIndexOf(".");
          const fileName1 = fileName.substring(0, lastDot);
          const ext = fileName.substring(lastDot + 1);
         
          let result ;
          let URL ;
          if(ext === 'pdf')
          {
             URL = documentPredictionEndPoint(projectName, fileName, outPutFormat);
          }
          else
          {
            URL = documentPredictionimgEndPoint(projectName, fileName, outPutFormat);
          }

  
          //new change end


       // const URL = documentPredictionEndPoint(projectName, fileName, outPutFormat);
        console.log("prediction url",URL);
        try {

            const analysedData = await axios(URL, { method: "POST", headers, data: {token: accessTokenBody}, cancelToken: this.cancelToken.token });
            //  debugger;
            if (analysedData) {
                this.setState({ analyseDataLoad: false });
                if (outPutFormat === "transform" && analysedData.data) {
                    this.setState({ analyzeResult: analysedData.data,analyzePResult:analysedData.data, outPutFormat: "Transform JSON Response" });
                } else if (outPutFormat === "raw" && analysedData.data) {
                    this.setState({ analyzeResult: analysedData.data, outPutFormat: "Raw JSON Response" });
                          //
 //store this data to use in Transformations
 const projectId = this.props.match.params["projectId"];
 const recentProject = this.props.recentProjects.find((project) => project.id === projectId);
const projectCopy = Object.assign({}, recentProject);
projectCopy.analyzeResult =  analysedData.data;
// projectCopy.folderPath = `${projectName}-${userId}/testing`;
await this.props.actions.saveProject(projectCopy, false, false);
await this.props.actions.loadProject(projectCopy);

 //
                          //
                           console.log("analyze result"+ JSON.stringify(analysedData.data));
                          if(analysedData.data)
                          {
                              if(analysedData.data.predictions)
                              {
                         const regions = analysedData.data.predictions.map((prd,index)=>
                         {  
                         return {
                              id: prd.tagId ,
                              type: "RECTANGLE",
                              tags: prd.tagName ? [prd.tagName] : [],            
                              pageNumber:1,
                              category: null,
                              value:" ",                            
                           boundingBox: prd.boundingBox,
                              points: [] ,  
                              probability:prd.probability,
                          };
                        
                      });
                  
                      const selectedAsset = this.state.selectedAsset;
                     
                          selectedAsset.regions = regions;
                          this.setState({
                            selectedAsset: selectedAsset,
                        });                       
                        }
                      }

                          //

                          //
  

                          //
                       
                } else if (analysedData.data.error) {
                    const data2 = analysedData.data.error.substr(analysedData.data.error.indexOf(":") + 1); // "tocirah sneab"
                    const errorJson = JSON.parse(data2);
                    this.setState({ errorMessage: errorJson });
                }
            } else {
                this.setState({ analyseDataLoad: false });
            }

        } catch (err) {
            let response;
            this.setState({ analyseDataLoad: false });
            if (err && err.response && err.response.status == 401) {
                const body = {
                    refreshToken: refreshTokenCall()
                }
                response = await ServiceHelper.postWithAutoRetry(
                    refreshTokenEndPoint(), body, { headers });
                if (response.data.status == 200) {
                    const signInUserSession = localStorage.getItem("signInUserSession");
                    const user = signInUserSession && JSON.parse(signInUserSession);
                    const updateAccessToken = Object.assign({}, user)
                    updateAccessToken.access_token = response.data.access_token
                    updateAccessToken.refreshx_token = response.data.refresh_token
                    try {
                        const analysedData = await axios(URL, { method: "POST", data: {token: response.data.access_token}, headers });
                        if (analysedData) {
                            this.setState({ analyseDataLoad: false });
                            if (outPutFormat === "transform" && analysedData.data) {
                                this.setState({ analyzeResult: analysedData.data, outPutFormat: "Transform JSON Response" });
                            } else if (outPutFormat === "raw" && analysedData.data) {
                                this.setState({ analyzeResult: analysedData.data, outPutFormat: "Raw JSON Response" });
                            } else if (analysedData.data.error) {
                                const data2 = analysedData.data.error.substr(analysedData.data.error.indexOf(":") + 1); // "tocirah sneab"
                                const errorJson = JSON.parse(data2);
                                this.setState({ errorMessage: errorJson });
                            }
                        } else {
                            this.setState({ analyseDataLoad: false });
                        }
                    } catch (err) {
                        ServiceHelper.handleServiceError(err);
                    }

                }
            } else {
                if (this.cancelToken === undefined) {
                ServiceHelper.handleServiceError(err);
                }
            }
        }
    }
   // }
    }

    private onFocused = () => {
        this.loadProjectAssets();
    }

    private nextPage = async () => {
        if ((this.state.pdfFile !== null || this.state.tiffImages.length !== 0)
            && this.state.currentPage < this.state.numPages) {
            await this.goToPage(this.state.currentPage + 1);
        }
    }

    private prevPage = async () => {
        if ((this.state.pdfFile !== null || this.state.tiffImages.length !== 0) && this.state.currentPage > 1) {
            await this.goToPage(this.state.currentPage - 1);
        }
    }
    
    private shouldShowPreviousPageButton = () => {
        return (this.state.pdfFile !== null || this.state.tiffImages.length !== 0) && this.state.currentPage !== 1;
    }

    private shouldShowNextPageButton = () => {
        return (this.state.pdfFile !== null || this.state.tiffImages.length !== 0)
            && this.state.currentPage !== this.state.numPages;
    }

    private shouldShowMultiPageIndicator = () => {
        return (this.state.pdfFile !== null || this.state.tiffImages.length !== 0) && this.state.numPages > 1;
    }

    private goToPage = async (targetPage: number) => {
        if (targetPage < 1 || targetPage > this.state.numPages) {
            // invalid page number, just return
        }
        // switch image
        await this.switchToTargetPage(targetPage);

    }

    private switchToTargetPage = async (targetPage: number) => {
        if (this.state.pdfFile !== null) {
            await this.loadPdfPage(this.state.selectedAsset.asset.id, this.state.pdfFile, targetPage);
        } else if (this.state.tiffImages.length !== 0) {
            this.loadTiffPage(this.state.tiffImages, targetPage);
        }
    }
    /** Result format type */
    private getFormatType = (selectedFormat: any) => {
        this.setState({ selectedFormat });
    }
}
